<template>
<v-dialog v-model="dialogSaveOnebox" max-width="500px" max-height="500px" persistent style="overflow-y: hidden;">
  <v-card style="border-radius:20px;">
    <v-card tile>
      <v-toolbar card style="background: #1a222c !important;">
        <v-toolbar-title class="white--text CSChatThai" v-if="!state"><v-icon color="white">fas fa-user-circle</v-icon>&nbsp;<span class="font-size14">{{$t('Dialog.Saveonebox.titleaccount')}}</span></v-toolbar-title>
        <v-toolbar-title class="white--text CSChatThai" v-else><v-icon color="white">fas fa-folder</v-icon>&nbsp;<span class="font-size14">{{$t('Dialog.Saveonebox.titlefolder')}}</span></v-toolbar-title>
        <v-spacer></v-spacer>

        <v-btn dark icon flat @click.native="closeDialog">
          <v-icon style="color: white !important; font-size: 20px !important;">clear</v-icon>
        </v-btn>
      </v-toolbar>
    </v-card>
    <v-card-title v-if="state">
      <v-btn round flat small color="white" @click="state = !state" class="color-grey">
        <v-icon color="primary" class="pr-2">fas fa-chevron-left</v-icon>
        {{$t('Task.allTask.back')}}
      </v-btn>
      <!-- <span class="ml-2 color-grey cursor-pointer" @click="state = !state">ย้อนกลับ</span> -->
    </v-card-title>
    <v-card-text style="padding: 0; height: 250px !important;" v-if="!state" class="scrolling-wrapper">
      <v-layout row wrap align-center justify-center v-if="progress" style="height: 250px;">
        <v-progress-circular size="50" :indeterminate="progress" color="primary"></v-progress-circular>
      </v-layout>
      <v-list two-line v-else>
        <template v-for="(item, index) in list_account">
          <v-list-tile
            :key="item.account_id"
            class="cursor-pointer"
            @click="get_mainfolder(item.account_id)"
          >
            <v-list-tile-avatar>
              <img src="/static/img/default_profile/man-white.png" class="border-img">
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title v-html="item.account_name" class="font-size14"></v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider
              v-if="index + 1 < list_account.length"
              :key="index"
            ></v-divider>
        </template>
      </v-list>
    </v-card-text>

    <v-card-text style="padding: 0; height: 200px !important;" v-else class="scrolling-wrapper">
      <v-layout row wrap align-center justify-center v-if="progress" style="height: 170px;">
        <v-progress-circular size="50" :indeterminate="progress" color="primary"></v-progress-circular>
      </v-layout>
      <v-list two-line v-else>
        <template v-for="(item, index) in list_folder">
          <v-list-tile
            :key="item.folder_id"
            class="cursor-pointer"
            @click="save_onebox(item.folder_id)"
          >
            <v-list-tile-avatar>
              <v-icon color="primary">fas fa-folder-open</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title v-html="item.folder_name" class="font-size14"></v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider
              v-if="index + 1 < list_folder.length"
              :key="index"
            ></v-divider>
        </template>
      </v-list>
    </v-card-text>
  </v-card>
</v-dialog>
</template>
<script>
import { Decode } from '@/services'
export default {
  data () {
    return {
      tokenuser: '',
      tokenmessage: '',
      list_account: [],
      list_folder: [],
      progress: false,
      state: false,
      account_id: ''
    }
  },
  props: {
    dialogSaveOnebox: false,
    tokenmessage_savebox: ''
  },
  watch: {
    dialogSaveOnebox () {
      this.tokenmessage = this.tokenmessage_savebox
      var decoded =  JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
      this.tokenuser = decoded['tokenuser']
      this.get_account()
    }
  },
  methods: {
    closeDialog () {
      this.state = false
      this.$emit('closeSaveOnebox', false)
    },
    get_mainfolder (id) {
      this.progress = true
      this.state = true
      this.account_id = id
      this.axios.post(process.env.APIpub + '/api/box/get_mainfolder_byaccountid', { account_id: this.account_id }).then((response) => {
        // console.log(response.data)
        if (response.data.status === 'success') {
          this.progress = false
          this.list_folder = response.data.data
          // console.log(this.list_folder)
        }
      }).catch((error) => {
        this.progress = false
        console.log(error)
      })
    },
    get_account () {
      this.progress = true
      this.axios.post(process.env.APIpub + '/api/box/get_account_byuserid', { user_id: this.tokenuser }).then((response) => {
        // console.log(response.data)
        if (response.data.status === 'success') {
          this.progress = false
          this.state = false
          this.list_account = response.data.data
          // console.log(this.list_account)
        }
      }).catch((error) => {
        this.progress = false
        console.log(error)
      })
    },
    save_onebox (id) {
      this.$swal({
        type: 'warning',
        title: '<div class="CSChatThai" style="font-size: 16px;">' + this.$t('Alert.Saveonebox') + '</div>',
        confirmButtonColor: '#2562af',
        confirmButtonText: '<div class="CSChatThai" style="font-size: 14px;">' + this.$t('AnswerQuestion.ok') + '</div>',
        cancelButtonColor: '#9f9f9f',
        cancelButtonText: '<div class="CSChatThai" style="font-size: 14px;">' + this.$t('AnswerQuestion.cancel') + '</div>',
        buttonsStyling: true,
        showCloseButton: true,
        showCancelButton: true,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.axios.post(process.env.APIpub + '/api/box/savefile', { account_id: this.account_id, folder_id: id, tokenmessage: this.tokenmessage_savebox }).then((response) => {
            // console.log(response.data)
            if (response.data.status === 'success') {
              this.$swal(
                this.$t('Alert.Success.sending'),
                this.$t('Alert.Success.sendFile'),
                'success'
              )
              this.$emit('closeSaveOnebox', false)
            }
          }).catch((error) => {
            this.progress = false
            this.$swal('', this.$t('Alert.Unsavefile'), 'warning')
            // this.$swal('', 'ไฟล์นี้ถูกบันทึกแล้ว ไม่สามารถบันทึกไฟล์ซ้ำได้', 'warning')
            console.log(error)
          })
        }
      })
    }
  }
}
</script>
<style type="text/css" scoped>
.scrolling-wrapper {
  /*display: flex;*/
  overflow-y: auto;
}
.scrolling-wrapper::-webkit-scrollbar {
  height: 4px;
  width: 8px;
}
.scrolling-wrapper::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background: rgba(0, 0, 0, .1);
}
>>>.v-list--two-line .v-list__tile {
  height: 50px !important;
}
>>>.v-icon .fas .fa-chevron-left .theme--light .primary--text {
  transition: none !important;
  padding-right: 10px !important;
}
>>>.v-btn:not(.v-btn--disabled):not(.v-btn--floating):not(.v-btn--icon) .v-btn__content .v-icon {
  -webkit-transition: none;
  transition: none;
  font-size: 18px;
}
>>>.v-card__title {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  padding-left: 0px;
  padding-bottom: 0px;
  padding-top: 0px;
}
.border-img {
  border-style: solid;
  border-width: thin;
  border-color: #ccc;
}
.font-size14 {
  font-size: 14px !important;
}
.cursor-pointer {
  cursor: pointer;
}
>>>.v-btn--floating.v-btn--small {
  height: 32px !important;
  width: 32px !important;
}
.color-grey {
  color: #1d1d1d !important;
}
</style>



// WEBPACK FOOTER //
// src/components/chat/dialog/saveonebox/SaveoneboxDialog.vue